/**
 * CHHA Visit Note — options + empty payload.
 * After shared common header (1–6): visit info → condition → vitals →
 * personal care → mobility/nutrition → meds/skin → safety/education → status.
 */

import { emptyChhaCommonHeader } from "./chhaNotesCommonHeaderUtils";

export const MENTAL_STATUS_OPTIONS = [
  "Alert/Oriented",
  "Confused",
  "Forgetful",
  "Lethargic",
];

export const PERSONAL_CARE_OPTIONS = [
  "Bathing (Sponge/Tub/Shower)",
  "Grooming (Hair/Shave)",
  "Dressing Assistance",
  "Toileting / Pericare",
  "Oral Care / Denture Care",
];

export const AMBULATION_OPTIONS = [
  "Independent",
  "Assisted (Min/Mod/Max)",
  "Dependent",
  "Bedbound",
];

export const TRANSFER_ASSISTANCE_OPTIONS = [
  "Independent",
  "Assisted",
  "Dependent",
  "Max Assist",
];

export const ASSISTIVE_DEVICE_OPTIONS = [
  "Cane/Walker",
  "Wheelchair",
  "Hoyer Lift",
  "Gait Belt",
];

export const NUTRITION_ASSISTANCE_OPTIONS = [
  "Independent",
  "Set-up only",
  "Partial assist",
  "Full assist",
];

export const SKIN_OBSERVATION_OPTIONS = [
  "Skin Intact",
  "Redness/Bruising",
  "Open Area",
  "Rash",
];

export const HOME_HAZARD_OPTIONS = [
  "None Observed",
  "Clutter / Fall risk",
  "Poor lighting",
  "Pets",
  "Other",
];

export const SAFETY_MEASURE_OPTIONS = [
  "Bed in low position",
  "Call light/phone in reach",
  "Nonslip socks/shoes on",
];

export const EDUCATION_RESPONSE_OPTIONS = ["Verbalized", "Demonstrated"];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable CHHA Visit Note payload (JSON on dedicated row). */
export const emptyChhaVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",
  visitDate: "",
  commonHeader: emptyChhaCommonHeader(),

  // —— 7. Visit Information ——
  supervisingRn: "",

  // —— 8. Patient Condition Upon Arrival ——
  mentalStatus: "",
  moodObservations: "",

  // —— 9. Vital Signs (Optional) ——
  bpSitting: "",
  pulseBpm: "",
  tempF: "",
  respBpm: "",
  weightLbs: "",

  // —— 10. Personal Care Provided ——
  personalCare: [],
  personalCareNotes: "",

  // —— 11. Mobility & Transfers ——
  ambulationLevel: "",
  transferAssistance: "",
  assistiveDevices: [],

  // —— 12. Nutritional Support ——
  mealPrepFeeding: "",
  mealCompletionPercent: "",
  fluidIntake: "",
  nutritionAssistance: "",

  // —— 13. Medication Reminders ——
  remindedPatientMeds: false,
  medicationReminderNotes: "",

  // —— 14. Skin Observation ——
  skinObservations: [],
  skinLocationDetails: "",
  reportedSkinConcernToRn: false,

  // —— 15. Safety Assessment ——
  homeEnvironmentHazards: "",
  safetyMeasuresTaken: [],

  // —— 16. Patient/Caregiver Education ——
  educationTopic: "",
  educationResponse: "",

  // —— 17. Status Changes & Response ——
  changesInCondition: "",
  communicatedToSupervisingRn: false,
  generalResponseNotes: "",
});

export const CHHA_VISIT_ARRAY_KEYS = [
  "personalCare",
  "assistiveDevices",
  "skinObservations",
  "safetyMeasuresTaken",
];
